export default __webpack_public_path__ + "static/banner-vector-92d6317540a86429095e1252b98351db.png";